module.exports = __webpack_public_path__ + "static/media/logo-cospor-distribuciones.be774a34.JPG";